import { v4 as uuidv4 } from 'uuid';
import { FilterTreeType, FILTER_TREE_TYPE } from 'constants/filter';
import { TransformedFilterTreeNode } from 'components/tree/FilterTree';

//
// --- Types ---

export interface FilterTreeNode {
  checked: boolean | null;
  children: ReadonlyArray<FilterTreeNode>;
  expandable: boolean;
  expanded: boolean;
  fieldMap: {};
  filterId: string | null;
  filterPrimaryKey: string | null;
  filterType: string | null;
  isRoot: boolean;
  name: string | null;
}

//
// --- Search Filter Transforms ---

/**
 * Takes in an array of raw data objects from the loadSearchFilters API request and returns an array of
 * transformed filter tree node objects to use in a filter tree panel
 */
export function transformRawFilterNodeCollectionToTreeNodes(
  rawFilterTreeNodes: ReadonlyArray<FilterTreeNode>,
  filterTreeType: FilterTreeType
): ReadonlyArray<TransformedFilterTreeNode> {
  if (!Array.isArray(rawFilterTreeNodes) || !rawFilterTreeNodes.length) {
    return [];
  }

  return rawFilterTreeNodes.map(rawFilterTreeNode =>
    transformRawFilterNodeToFilterTreeNode(rawFilterTreeNode, filterTreeType)
  );
}

/**
 * Takes in a raw node (results from API) and converts it to a transformed tree node, including
 * appending tree node ids, parentIds, default open status, and leaf status.
 */
export const transformRawFilterNodeToFilterTreeNode = (
  treeNode: FilterTreeNode,
  filterTreeType: FilterTreeType,
  parentId: string | null = null
): TransformedFilterTreeNode => {
  // need to change treenodeid here
  const treeNodeId =
    (filterTreeType === FILTER_TREE_TYPE.ITEM ||
    filterTreeType === FILTER_TREE_TYPE.DIVERSITY_CLASSIFICATION ||
    filterTreeType === FILTER_TREE_TYPE.QUALIFICATION ||
    filterTreeType === FILTER_TREE_TYPE.SEGMENTATION
      ? treeNode.filterPrimaryKey
      : treeNode.filterId) || uuidv4(); // use id if available, otherwise assign uuid
  const hasChildren = Array.isArray(treeNode.children) && treeNode.children.length > 0;

  return {
    ...treeNode,
    children: hasChildren
      ? treeNode.children.map((childNode: FilterTreeNode) =>
          transformRawFilterNodeToFilterTreeNode(childNode, filterTreeType, treeNodeId)
        )
      : [],
    filterTreeType,
    id: treeNodeId,
    leaf: !hasChildren,
    open: false,
    parentId
  };
};
